export const SUNBED_MODEL_TYPES_MODAL_EVENTS = `modals:sunbed-model-types`;

export const SUNBED_MODEL_TYPE_DUPLICATE = `SUNBED_MODEL_TYPE:DUPLICATE`;

export const SUNBED_MODEL_TYPE_UV_TYPE_CONFIGURATION_MODAL = `${SUNBED_MODEL_TYPES_MODAL_EVENTS}:marking`;
export const SUNBED_MODEL_TYPE_UV_TYPE_CONFIGURATION_MODAL_OPEN = `${SUNBED_MODEL_TYPE_UV_TYPE_CONFIGURATION_MODAL}:open`;
export const SUNBED_MODEL_TYPE_UV_TYPE_CONFIGURATION_MODAL_CLOSE = `${SUNBED_MODEL_TYPE_UV_TYPE_CONFIGURATION_MODAL}:close`;
